module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select_date_range":"Select date range","tooltip":"Click to change the global date range"},"cs":{"select_date_range":"Vyberte rozmezí dat","tooltip":"Kliknutím změníte globální nastavení zobrazovaného rozmezí dat"}}')
  delete Component.options._Ctor
}
